import { Menu, Transition } from '@headlessui/react';
import {
	ChevronLeftIcon,
	Cog6ToothIcon,
	ExclamationTriangleIcon,
} from '@heroicons/react/20/solid';
import {
	ChevronRightIcon,
	ShieldCheckIcon,
	XMarkIcon,
} from '@heroicons/react/24/outline';
import moment from 'moment';
import React, { Fragment, useContext, useEffect, useState } from 'react';

import SocketContext from '../../context/SocketContext';

import { classNames, createDataTree } from '../../components/helpers/functions';
import Modal from '../../components/Shell/Modal';
import Button from '../../components/Button';
import BetaAttributes from '../../components/Attributes';
import { AttributeRow } from '../../components/Attributes/Attributes_old';
// TODO: Update to use AssetSelectorBeta
// import SelectAsset from '../../components/SelectAsset';
import { FormRow } from '../../components/Form/tailwindForm';
import ScrollingCalendar from './ScrollingCalendar';

import useModal from '../../hooks/useModal';
import usePrevious from '../../hooks/usePrevious';
import useAsync from '../../hooks/useAsync';

import { addTicket, getLocations } from '../../api';

import LogoMark from '../../images/logo-mark.png';

import { STATUS_MAPPING } from '../../components/helpers/constants';
import SelectLocations from '../../components/SelectLocation';
import useLocal from '../../hooks/useLocal';
import { useNavigate } from 'react-router-dom';
import Ticker from '../../components/Ticker';

const Clock = () => {
	const TIME_FORMAT = 'dddd, MMMM Do, h:mm A';
	const [time, setTime] = useState(moment().format(TIME_FORMAT));

	useEffect(() => {
		const timer = setInterval(() => {
			setTime(moment().format(TIME_FORMAT));
		}, 30000);
		return () => clearInterval(timer);
	}, []);
	return time;
};

const TabletView = () => {
	const [addTicketOpen, setAddTicketOpen] = useState(false);
	const [form, setForm] = useState({});
	const [previewMode, setPreviewMode] = useState(false);
	const [currentPage, setCurrentPage] = useState('home');
	const { setOpen: onOpenCreateTicket } = useModal('ticketOverviewTablet');

	const { get } = useLocal();
	const user = get('user');

	const navigate = useNavigate();

	const [locationStatus, setLocationStatus] = useState(null);

	const {
		initialize: socketInitialize,
		socket: socketIO,
		connect: socketConnect,
		disconnect: socketDisconnect,
		connected: socketConnected,
		payload: socketPayload,
		setPayload: setSocketPayload,
		error: socketError,
		setError: setSocketError,
	} = useContext(SocketContext);

	const location = socketPayload?.locationId;

	const handleSocketConnect = () => {
		if (socketPayload?.locationId) {
			socketConnect();
		} else {
			//setSocketError({ message: 'Failed to connect: Missing location' });
		}
	};

	const { open, setClose } = useModal('tabletView');

	const {
		value: locations,
		execute: onRefreshLocations,
		status: isLoadingLocations,
	} = useAsync(getLocations);

	const {
		execute: onAdd,
		status: isAddingTicket,
		error,
		resetError,
	} = useAsync(addTicket, {
		immediate: false,
	});

	const prevOpen = usePrevious(open);
	const prevLocation = usePrevious(location);
	const prevSocketIO = usePrevious(socketIO);
	const prevSocketConnected = usePrevious(socketConnected);
	const prevTicketOpen = usePrevious(addTicketOpen);

	useEffect(() => {
		if (!addTicketOpen && prevTicketOpen) {
			setForm({ locationId: socketPayload?.locationId });
		}
	}, [addTicketOpen]);

	useEffect(() => {
		if (open && !prevOpen) {
			socketInitialize();
		}
	}, [open, prevOpen]);

	useEffect(() => {
		if (socketIO && !prevSocketIO) {
			// Initialize SocketIO
			console.log('Tablet View: Initialize SocketIO');

			socketIO?.on('checkHealth', () => {
				socketIO?.emit('checkHealth', socketPayload);
			});

			socketIO?.on('setHealth', (tickets) => {
				console.log('setHealth: ', tickets);
				setLocationStatus(tickets);
			});
		}
	}, [socketIO, prevSocketIO]);

	useEffect(() => {
		if (socketIO) {
			socketIO?.on('removeListener', 'checkHealth');

			socketIO?.on('checkHealth', () => {
				console.log('set new check health');
				socketIO?.emit('checkHealth', socketPayload);
			});
		}
	}, [socketIO, socketConnected, socketPayload]);

	useEffect(() => {
		if (socketConnected && !prevSocketConnected) {
			socketIO?.emit('checkHealth', socketPayload);
		}
	}, [socketPayload, socketConnected, prevSocketConnected]);

	useEffect(() => {
		if (!socketPayload?.locationId) {
			onRefreshLocations();
			socketDisconnect();
		} else {
			if (!socketConnected) {
				socketConnect();
			}
			setForm({ locationId: socketPayload?.locationId });
		}
	}, [socketPayload?.locationId]);

	useEffect(() => {
		//	console.log('TabletView: is socket connected: ', socketConnected);
	}, [socketConnected, open, location]);

	/*useEffect(() => {
		if (open && !prevOpen) {
			socketInitialize();
		}
	}, [open, prevOpen]);

	useEffect(() => {
		if (open && !prevLocation) {
			if (location) {
				if (socketConnected) {
					//console.log('check tickets');
				} else {
					handleSocketConnect();
				}
			} else {
				socketDisconnect();
			}
		} else if (open && prevLocation) {
			if (!socketConnected) {
				handleSocketConnect();
			}
		} else {
			//console.log('tablet view closed');

			if (socketConnected) {
				socketDisconnect();
			}
			setLocationStatus(null);
		}
	}, [open, location]);

	useEffect(() => {
		if (socketIO) {
			socketIO?.on('connect', () => {
				console.log('socket connection established()', socketPayload);
				socketIO?.emit('checkHealth', socketPayload);
			});

			socketIO?.on('checkHealth', () => {
				console.log('check health', socketPayload);
				socketIO?.emit('checkHealth', socketPayload);
			});

			socketIO?.on('setHealth', (tickets) => {
				console.log('setHealth: ', tickets);
				setLocationStatus(tickets);
			});
		}
	}, [socketIO, socketPayload]);
*/
	const CONFIG = {
		operational: {
			border: 'border-green-500',
			textColor: 'text-green-700',
			title: locationStatus?.name,
			children: [],
			events: [],
		},
		event: {
			border: 'border-blue-500',
			textColor: 'text-blue-700',
			title: '1 Service Event Today',
			children: [],
			events: [
				<li
					className="relative mt-px flex"
					style={{ gridRow: '134 / span 18' }}
				>
					<a
						href="#"
						className="group absolute inset-1 flex flex-col overflow-y-auto rounded-lg bg-indigo-50 p-2 text-xs leading-5 hover:bg-indigo-100"
					>
						<p className="order-1 font-semibold text-indigo-700">LRP Visit</p>
						<p className="order-1 text-indigo-500 group-hover:text-indigo-700">
							Liconic STX220 (S/N 1223)
						</p>
						<p className="text-indigo-500 group-hover:text-indigo-700">
							<time dateTime="2022-01-22T11:00">11:00 AM</time>
						</p>
					</a>
				</li>,
			],
		},
		caution: {
			border: 'border-yellow-500',
			title: locationStatus?.name,
		},
		down: {
			border: 'border-red-500',
			textColor: 'text-red-700',
			title: locationStatus?.name,
			children: [
				<>
					{locationStatus?.tickets?.map((ticket) => (
						<div className="rounded-md bg-red-50 p-4">
							<div className="flex items-center">
								<div className="flex-shrink-0">
									<ExclamationTriangleIcon
										className="h-5 w-5 text-red-400"
										aria-hidden="true"
									/>
								</div>
								<div className="ml-3 flex-grow">
									<h3 className="text-sm font-medium text-red-800">
										{`[${ticket?.ticketCode}] - ${ticket?.subject}`}
									</h3>
									<p className="text-xs text-red-800/70">
										{ticket?.asset ? '' : ``}
									</p>
								</div>
								<div>
									<ChevronRightIcon className="w-4 h-4 text-red-800 font-medium" />
								</div>
							</div>
						</div>
					))}
				</>,
			],
			events: [],
		},
	}[
		locationStatus?.health === 'partialDisruption' ||
		locationStatus?.health === 'completeDisruption' ||
		locationStatus?.health === 'disruption' ||
		locationStatus?.health === 'partialOutage' ||
		locationStatus?.health === 'locationDisruption'
			? 'caution'
			: locationStatus?.health === 'locationOutage' ||
			  locationStatus?.health === 'completeOutage' ||
			  locationStatus?.health === 'outage' ||
			  locationStatus?.health === 'locationOutage'
			? 'down'
			: 'operational'
	];

	const locationTree = locations?.rows ? createDataTree(locations?.rows) : null;

	let ticketList = [];
	const assetTickets = locationStatus?.assets?.flatMap((asset) =>
		asset?.tickets?.map((ticket) => ({ ...ticket, asset }))
	);
	if (assetTickets?.length) {
		ticketList = [...ticketList, ...assetTickets];
	}
	if (locationStatus?.tickets?.length) {
		ticketList = [...ticketList, ...locationStatus?.tickets];
	}

	const LocationList = ({ deployment, depth = 1 }) => {
		return (
			<>
				<li
					key={deployment.id}
					className="relative flex items-center space-x-4 py-4 cursor-pointer"
					onClick={() => {
						setSocketPayload({ locationId: deployment?.id });
						console.log('TabletView: set payload new location');
						//socketIO?.emit('checkHealth', { locationId: deployment?.id });
					}}
				>
					<div
						className="min-w-0 flex-auto"
						style={{
							marginLeft: `${1.75 * (depth - 1)}rem`,
						}}
					>
						<div className="flex items-center gap-x-3">
							<div
								className={classNames(
									STATUS_MAPPING[deployment.health]?.glow,
									'flex-none rounded-full p-1'
								)}
							>
								<div className="h-2 w-2 rounded-full bg-current" />
							</div>
							<h2 className="min-w-0 text-sm font-semibold leading-6 text-white">
								<a href={deployment.href} className="flex gap-x-2">
									<span className="truncate">{deployment.name}</span>
									<span className="absolute inset-0" />
								</a>
							</h2>
							{/*locationStatus?.tickets?.map((ticket) => (
								<div className="rounded-md bg-red-50 p-4">
									<div className="flex items-center">
										<div className="flex-shrink-0">
											<ExclamationTriangleIcon
												className="h-5 w-5 text-red-400"
												aria-hidden="true"
											/>
										</div>
										<div className="ml-3 flex-grow">
											<h3 className="text-sm font-medium text-red-800">
												{`[${ticket?.ticketCode}] - ${ticket?.subject}`}
											</h3>
											<p className="text-xs text-red-800/70">
												{ticket?.asset ? '' : ``}
											</p>
										</div>
										<div>
											<ChevronRightIcon className="w-4 h-4 text-red-800 font-medium" />
										</div>
									</div>
								</div>
							))*/}
						</div>
					</div>
					<ChevronRightIcon
						className="h-5 w-5 flex-none text-gray-400"
						aria-hidden="true"
					/>
				</li>{' '}
				{deployment?.children?.length
					? deployment.children.map((c, i) => (
							<LocationList deployment={c} depth={depth + 1} />
					  ))
					: null}
			</>
		);
	};

	//console.log('socket: ', socketConnected, socketIO, socketPayload);
	return (
		<Modal
			showCloseIcon={false}
			size="full"
			open={!!open}
			onClose={() => setClose()}
		>
			<div className="bg-gray-900 p-2 h-full">
				{location ? (
					<div
						className={classNames(
							'bg-gray-900 text-gray-400 border-4 rounded-xl p-10 h-full overflow-scroll',
							//CONFIG?.border,
							socketConnected ? CONFIG.border : 'animate-blinkingBorder'
						)}
					>
						{socketConnected ? (
							<div className="h-full flex flex-col">
								{currentPage === 'home' ? (
									<>
										<div className="col-span-8 flex-grow">
											<div className="flex flex-col justify-between col-span-12">
												<div className="mb-8">
													<ShieldCheckIcon
														className={classNames(
															'w-10 h-10 mb-4',
															CONFIG?.textColor
														)}
													/>
													<div className="text-lg">
														<Clock />
													</div>
													<div className="text-6xl font-medium leading-snug text-gray-300">
														{socketConnected ? CONFIG.title : 'Not connected'}
													</div>
												</div>
											</div>
										</div>
										<div className="col-span-8 flex justify-between flex-col">
											<div className="mb-4">
												<table className="w-full table-auto border-collapse">
													<tbody>
														{ticketList?.length ? (
															<>
																<tr>
																	<td colSpan={2}>
																		<div className="flex items-center mb-2 justify-between border-b border-gray-700 text-sm pb-3">
																			<span className="font-semibold text-white mr-2">
																				LATEST OPEN TICKETS
																			</span>{' '}
																			{previewMode && (
																				<span
																					className="text-gray-400"
																					onClick={() =>
																						setCurrentPage('tickets')
																					}
																				>
																					View All Tickets (
																					{ticketList?.length || 0})
																				</span>
																			)}
																		</div>
																	</td>
																</tr>

																{ticketList
																	?.sort(
																		(a, b) =>
																			new Date(b.createdAt) -
																			new Date(a.createdAt)
																	)
																	?.map((ticket) => {
																		return (
																			<tr
																				className="rounded-md border-amber-100/25 cursor-pointer"
																				onClick={() =>
																					onOpenCreateTicket({
																						id: ticket?.id,
																						isBare: true,
																					})
																				}
																			>
																				<td className="w-1 whitespace-nowrap py-4 px-2  text-gray-400">
																					<Ticker date={ticket?.createdAt} />
																				</td>
																				<td className="py-4 px-2 ">
																					<div className="flex items-center">
																						<div className="flex-shrink-0"></div>
																						<div className="ml-3 flex-grow">
																							<h3 className=" font-medium text-white">
																								{`${
																									ticket?.asset?.manufacturer
																										?.name
																										? `${ticket?.asset?.manufacturer?.name} ${ticket?.asset?.model?.name} S/N: ${ticket?.asset?.serialNumber} Tag: ${ticket?.asset?.tag}`
																										: `[${
																												ticket?.ticketCode ||
																												locationStatus?.name
																										  }]`
																								}`}
																							</h3>
																							<p className="text-gray-400 mt-1">
																								{ticket?.subject}
																							</p>
																						</div>
																						<div>
																							<ChevronRightIcon className="w-4 h-4 text-white font-medium" />
																						</div>
																					</div>
																				</td>
																			</tr>
																		);
																	})}
															</>
														) : null}
														{previewMode ? (
															<>
																<tr>
																	<td colSpan={2}>
																		<div className="flex items-center mb-3 justify-between border-b border-gray-700 text-sm pb-2 mt-6">
																			<span className="font-semibold text-white mr-2">
																				UPCOMING EVENTS
																			</span>{' '}
																			<span className="text-gray-400">
																				View All Events
																			</span>
																		</div>
																	</td>
																</tr>
																<tr
																	className="rounded-md border-amber-100/25 cursor-pointer"
																	onClick={() => {}}
																>
																	<td className="w-1 whitespace-nowrap py-4 px-2 text-gray-400">
																		<Ticker date={new Date()} fromNow={false} />
																	</td>
																	<td className=" py-4 px-2 ">
																		<div className="flex items-center">
																			<div className="flex-shrink-0"></div>
																			<div className="ml-3 flex-grow">
																				<h3 className=" font-medium text-white">
																					Scipods
																				</h3>
																			</div>
																			<div>
																				<ChevronRightIcon className="w-4 h-4 text-white font-medium" />
																			</div>
																		</div>
																	</td>
																</tr>
															</>
														) : null}
													</tbody>
												</table>

												{/*<div className="p-4 text-center">No events scheduled</div>*/}
											</div>
											<div className="flex justify-between items-center border-t border-gray-700 pt-10">
												<div className="flex items-center text-sm">
													<img src={LogoMark} className="w-10 h-10 mr-3 " />{' '}
													<span className="text-white ml-1 text-lg">
														Scipods ONE
													</span>
												</div>
												<div className="flex items-center">
													<button
														onClick={() => setAddTicketOpen(true)}
														className="focus:outline-none inline-flex items-center rounded-md border font-medium  text-gray-300  border-2 border-gray-600 py-4 px-8 bg-transparent"
													>
														Report an Issue
													</button>

													<Menu
														as="div"
														className="relative inline-block text-left ml-4"
													>
														<div className="flex">
															<Menu.Button className="inline-flex w-full justify-center gap-x-1.5  px-3 py-2 items-center">
																<Cog6ToothIcon className="w-6 h-6 text-gray-500" />
															</Menu.Button>
														</div>

														<Transition
															as={Fragment}
															enter="transition ease-out duration-100"
															enterFrom="transform opacity-0 scale-95"
															enterTo="transform opacity-100 scale-100"
															leave="transition ease-in duration-75"
															leaveFrom="transform opacity-100 scale-100"
															leaveTo="transform opacity-0 scale-95"
														>
															<Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none bottom-full">
																<div className="py-1">
																	<Menu.Item>
																		{({ active }) => (
																			<div
																				className={classNames(
																					active
																						? 'bg-gray-100 text-gray-900'
																						: 'text-gray-700',
																					'block px-4 py-2 text-xs cursor-pointer'
																				)}
																				onClick={() =>
																					socketIO?.emit(
																						'checkHealth',
																						socketPayload
																					)
																				}
																			>
																				Check Health
																			</div>
																		)}
																	</Menu.Item>
																	<Menu.Item>
																		{({ active }) => (
																			<div
																				className={classNames(
																					active
																						? 'bg-gray-100 text-gray-900'
																						: 'text-gray-700',
																					'block px-4 py-2 text-xs cursor-pointer'
																				)}
																				onClick={() => setSocketPayload(null)}
																			>
																				Change Location
																			</div>
																		)}
																	</Menu.Item>
																	<Menu.Item>
																		{({ active }) => (
																			<div
																				className={classNames(
																					active
																						? 'bg-gray-100 text-gray-900'
																						: 'text-gray-700',
																					'block px-4 py-2 text-xs cursor-pointer'
																				)}
																				onClick={() => socketDisconnect()}
																			>
																				Disconnect Server
																			</div>
																		)}
																	</Menu.Item>
																	{user?.role?.name === 'default:tablet' ? (
																		<Menu.Item>
																			{({ active }) => (
																				<div
																					className={classNames(
																						active
																							? 'bg-gray-100 text-gray-900'
																							: 'text-gray-700',
																						'block px-4 py-2 text-xs cursor-pointer'
																					)}
																					onClick={() =>
																						setPreviewMode(!previewMode)
																					}
																				>
																					{previewMode
																						? 'Turn off preview mode'
																						: 'Turn on preview mode'}
																				</div>
																			)}
																		</Menu.Item>
																	) : null}
																	{user?.role?.name !== 'default:tablet' ? (
																		<Menu.Item>
																			{({ active }) => (
																				<div
																					className={classNames(
																						active
																							? 'bg-gray-100 text-gray-900'
																							: 'text-gray-700',
																						'block px-4 py-2 text-xs cursor-pointer'
																					)}
																					onClick={() => setClose()}
																				>
																					Exit Tablet Mode
																				</div>
																			)}
																		</Menu.Item>
																	) : (
																		<Menu.Item>
																			{({ active }) => (
																				<div
																					className={classNames(
																						active
																							? 'bg-gray-100 text-gray-900'
																							: 'text-gray-700',
																						'block px-4 py-2 text-xs cursor-pointer'
																					)}
																					onClick={() => navigate('/logout')}
																				>
																					Logout
																				</div>
																			)}
																		</Menu.Item>
																	)}
																</div>
															</Menu.Items>
														</Transition>
													</Menu>
												</div>
											</div>
										</div>
									</>
								) : currentPage === 'tickets' ? (
									<>
										<div
											className="flex items-center mb-6"
											onClick={() => setCurrentPage('home')}
										>
											<ChevronLeftIcon className="w-10 h-10 text-gray-400 mr-2" />
											<div className="text-lg text-gray-400">Back</div>
										</div>
										<div className="text-3xl font-medium leading-snug text-gray-300">
											All Open Tickets
										</div>
										<div></div>
									</>
								) : currentPage === 'events' ? (
									<>
										<div>Events</div>
									</>
								) : (
									<>
										<div>Something went wrong</div>
									</>
								)}
							</div>
						) : (
							<div className="flex items-center justify-center flex-col h-full">
								<div>
									{socketError?.message || 'Tablet not connected to server'}
								</div>

								<Menu as="div" className="relative inline-block text-left ml-4">
									<div className="flex">
										<Menu.Button className="inline-flex w-full justify-center gap-x-1.5 items-center p-6 focus:outline-none">
											<Cog6ToothIcon className="w-6 h-6 text-gray-500" />
										</Menu.Button>
									</div>

									<Transition
										as={Fragment}
										enter="transition ease-out duration-100"
										enterFrom="transform opacity-0 scale-95"
										enterTo="transform opacity-100 scale-100"
										leave="transition ease-in duration-75"
										leaveFrom="transform opacity-100 scale-100"
										leaveTo="transform opacity-0 scale-95"
									>
										<Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none bottom-full">
											<div className="py-1">
												<Menu.Item>
													{({ active }) => (
														<div
															className={classNames(
																active
																	? 'bg-gray-100 text-gray-900'
																	: 'text-gray-700',
																'block px-4 py-2 text-xs cursor-pointer'
															)}
															onClick={() => handleSocketConnect()}
														>
															Connect to Server
														</div>
													)}
												</Menu.Item>
												<Menu.Item>
													{({ active }) => (
														<div
															className={classNames(
																active
																	? 'bg-gray-100 text-gray-900'
																	: 'text-gray-700',
																'block px-4 py-2 text-xs cursor-pointer'
															)}
															onClick={() => setClose()}
														>
															Exit Tablet Mode
														</div>
													)}
												</Menu.Item>
											</div>
										</Menu.Items>
									</Transition>
								</Menu>
							</div>
						)}
					</div>
				) : (
					<div className="flex h-full justify-center items-center flex-col">
						<img className="h-24 w-auto mb-10" src={LogoMark} alt="Scipods" />
						<h3 className="text-white font-semibold text-2xl mb-3">
							Welcome to Scipods Tablet
						</h3>

						<div className="w-1/2">
							{locations?.rows?.length ? (
								<>
									<h3 className="text-gray-500 text-md mb-10 text-center">
										Please select a location
									</h3>
									<ul
										role="list"
										className="divide-y divide-white/5 max-h-96 overflow-auto"
									>
										{locationTree?.map((location) => (
											<LocationList deployment={location} />
										))}
									</ul>
								</>
							) : null}
						</div>
					</div>
				)}
			</div>

			<Modal
				open={addTicketOpen}
				onClose={() => setAddTicketOpen(false)}
				size="full"
				showCloseIcon={false}
			>
				<div className="px-4 py-4 sm:px-6 lg:px-8 border-b border-gray-200">
					<div className="mx-auto block sm:flex items-center justify-between gap-x-8 lg:mx-0">
						<div className="flex items-center gap-x-6">
							<h1>
								<div className="text-lg font-semibold text-gray-900">
									Create a ticket
								</div>
							</h1>
						</div>
						<div className="flex items-center">
							<XMarkIcon
								className="w-10 h-10 text-gray-700 p-2 cursor-pointer"
								onClick={() => setAddTicketOpen(false)}
							/>
						</div>
					</div>
				</div>
				<div className="grid grid-cols-8">
					<div className="grid gap-y-8 col-span-6 col-start-2 py-20">
						<AttributeRow isEditing={true}>
							<div className="block font-medium text-gray-700 mb-3 text-lg">
								Select a location
							</div>
							<SelectLocations
								onChange={(value) => {
									setForm({ ...form, locationId: value });
								}}
								value={form?.locationId}
								autoFocus={false}
								disableSearch={true}
							/>
						</AttributeRow>

						<AttributeRow isEditing={true}>
							<div className="block font-medium text-gray-700 mb-3 text-lg">
								Select an asset
							</div>
							{/* TODO: Replace with AssetSelectorBeta */}
							<div className="p-4 bg-yellow-50 border border-yellow-200 rounded text-sm">
								<p className="text-yellow-800">
									Asset selection disabled - needs AssetSelectorBeta integration
								</p>
							</div>
						</AttributeRow>

						<AttributeRow isEditing={true}>
							<div className="block font-medium text-gray-700 mb-3 text-lg">
								Describe issue
							</div>
							<BetaAttributes
								field={{ type: 'textarea', placeholder: 'Add a description' }}
								form={form}
								onChange={(index, summary) => setForm({ ...form, summary })}
							/>
						</AttributeRow>
						<div className="col-span-2 flex justify-end">
							<button
								className="focus:outline-none inline-flex items-center rounded-md border font-medium  text-white py-4 px-8 bg-indigo-600"
								onClick={() =>
									onAdd(configurePayload(form), () => setAddTicketOpen(false))
								}
							>
								{isAddingTicket === 'pending' ? 'Creating...' : 'Create ticket'}
							</button>
						</div>
					</div>
				</div>
			</Modal>
		</Modal>
	);
};

const configurePayload = ({
	assetId,
	locationId,
	summary,
	description,
} = {}) => ({
	assetId,
	location: locationId,
	summary,
	description,
	type: locationId ? 'location' : 'asset',
});

export default TabletView;

const Temp = () => {
	return (
		<div className="bg-gray-900 p-2 w-full h-full">
			<div
				className={classNames(
					'bg-gray-900 text-gray-400 w-full h-full border-4 rounded-xl p-20',
					CONFIG?.border
				)}
			>
				<div className="grid grid-cols-8 gap-x-12 h-full">
					<div className="col-span-5">
						<div className="flex flex-col justify-between h-full">
							<div className="mb-8">
								<ShieldCheckIcon
									className={classNames('w-10 h-10 mb-4', CONFIG?.textColor)}
								/>
								<div className="text-lg">
									<Clock />
								</div>
								<div className="text-6xl font-medium leading-snug text-gray-300">
									{CONFIG?.title}
								</div>
							</div>
							<div className="flex-grow">{CONFIG?.children}</div>
							<div className="flex items-center">
								<button className="focus:outline-none inline-flex items-center rounded-md border font-medium  text-gray-300  border-2 border-red-700/40 py-4 px-8 bg-transparent">
									Vendor Services
								</button>

								<button className="focus:outline-none inline-flex items-center rounded-md border font-medium  text-gray-300  border-2 border-red-700/40 py-4 px-8 bg-transparent">
									Report an Issue
								</button>

								<Menu as="div" className="relative inline-block text-left ml-4">
									<div className="flex">
										<Menu.Button className="inline-flex w-full justify-center gap-x-1.5  px-3 py-2 items-center">
											<Cog6ToothIcon className="w-6 h-6 text-gray-500" />
										</Menu.Button>
									</div>

									<Transition
										as={Fragment}
										enter="transition ease-out duration-100"
										enterFrom="transform opacity-0 scale-95"
										enterTo="transform opacity-100 scale-100"
										leave="transition ease-in duration-75"
										leaveFrom="transform opacity-100 scale-100"
										leaveTo="transform opacity-0 scale-95"
									>
										<Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none bottom-full">
											<div className="py-1">
												<Menu.Item>
													{({ active }) => (
														<div
															className={classNames(
																active
																	? 'bg-gray-100 text-gray-900'
																	: 'text-gray-700',
																'block px-4 py-2 text-xs cursor-pointer'
															)}
														>
															Set for Operational
														</div>
													)}
												</Menu.Item>
												<Menu.Item>
													{({ active }) => (
														<div
															className={classNames(
																active
																	? 'bg-gray-100 text-gray-900'
																	: 'text-gray-700',
																'block px-4 py-2 text-xs cursor-pointer'
															)}
														>
															Set for Event
														</div>
													)}
												</Menu.Item>
												<Menu.Item>
													{({ active }) => (
														<div
															className={classNames(
																active
																	? 'bg-gray-100 text-gray-900'
																	: 'text-gray-700',
																'block px-4 py-2 text-xs cursor-pointer'
															)}
														>
															Set for System Down
														</div>
													)}
												</Menu.Item>
												<Menu.Item>
													{({ active }) => (
														<div
															className={classNames(
																active
																	? 'bg-gray-100 text-gray-900'
																	: 'text-gray-700',
																'block px-4 py-2 text-xs cursor-pointer'
															)}
															onClick={() => setClose()}
														>
															Exit Tablet Mode
														</div>
													)}
												</Menu.Item>
											</div>
										</Menu.Items>
									</Transition>
								</Menu>
							</div>
						</div>
					</div>
					<div className="col-span-3 max-h-full overflow-scroll">
						<ScrollingCalendar />
					</div>
				</div>
			</div>
		</div>
	);
};
